import { useLoadingDialogStore } from '@/store/loadingDialogStore';
import { Box, Dialog, CircularProgress, LinearProgress } from '@mui/material';
import IMAGE from '@/assets/images/ava01_3.gif'

export default function LoadingDialog() {
    const isOpen = useLoadingDialogStore((state) => state.isLoadingOpen);
    return (
        <>
            <Dialog
                open={isOpen}
                sx={{ zIndex: 1500 }}
                PaperProps={{
                    style: {
                        width: '200px',
                        borderRadius: "50%",
                        boxShadow: 'none',
                        backgroundColor: '0,0,0,0'
                    }
                }}
            >
                <LinearProgress />
            </Dialog>
        </>
    );
}
